var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('a',{attrs:{"href":"https://github.com/khalisfoundation/anvaad-js","target":"_blank"}},[_vm._v("GitHub")]),_c('div',[_vm._v("© "),_c('a',{attrs:{"href":"https://khalisfoundation.org/","target":"_blank"}},[_vm._v("Khalis Foundation")]),_vm._v(" "+_vm._s(new Date().getFullYear()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }